import React from 'react'

import './paginatorStyle.css'

const Paginator = (props) => {
  return (
    <>
      {
        !!Object.keys(props.control).length &&
        <div className="paginator-container">
          <div className="pages-info no-select">
            <span>{(props.control.count > 0) ? props.control.page * props.control.pageSize + 1 : 0}</span>
            &nbsp; al &nbsp;
            <span>{((props.control.page + 1) * props.control.pageSize > props.control.count) ? props.control.count : (props.control.page + 1) * props.control.pageSize}</span>
            &nbsp; de &nbsp;
            <span>{props.control.count}</span>
          </div>
          {
            props.control.pages > 1 &&
            <div className='change-page-container'>
              {
                !!props.control.page &&
                <div className='arrow-page-change' onClick={() => props.click(props.control.page - 1)}><i className="fas fa-chevron-left"></i></div>
              }
              <div className='content-pages'>
                <div className='input-page-change-container'>
                  <input type='text' className='input-page-change' value={props.page} onChange={props.textChange} />
                </div>
                <div className='no-select'>/</div>
                <div className='no-select'>{props.control.pages}</div>
              </div>
              {
                !(props.control.page + 1 === props.control.pages) &&
                <div className='arrow-page-change' onClick={() => props.click(props.control.page + 1)}><i className="fas fa-chevron-right"></i></div>
              }
            </div>
          }
        </div>
      }
    </>
  )
}

export default Paginator